/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./lib/locales (ignored)
// module id = 2
// module chunks = 18